<template>
  <pagefra>
    <div class="historyNotice container">
      <panel type="toolbar">
        <div class="toolbar">
          <el-form
            class="toolbar-form"
            :inline="true"
            v-model="form"
            label-width
          >
            <el-form-item :label="$l('公告标题')">
              <el-input
                v-model="form.title"
                :placeholder="$l('公告标题')"
                style="width: 110px"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$l('创建人员')">
              <el-input
                v-model="form.creator"
                :placeholder="$l('创建人员')"
                style="width: 110px"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$l('开始时间')">
              <el-date-picker
                v-model="noticeTimeValues"
                type="datetimerange"
                :range-separator="$l('至')"
                :start-placeholder="$l('开始时间')"
                :end-placeholder="$l('结束时间')"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button
                icon="el-icon-search"
                type="primary"
                circle
                @click="search"
              ></el-button>
            </el-form-item>
          </el-form>
          <div class="toolbar-btn">
            <el-button icon="el-icon-close" round @click="deleteHistoryNotice"
              >{{ $l("删除") }}
            </el-button>
          </div>
        </div>
      </panel>
      <panel class="panel-table">
        <div class="panel-table__table">
          <el-table
            ref="filterTable"
            size="medium"
            tooltip-effect="tableTooltip"
            highlight-current-row
            height="100%"
            v-loading.lock="loading"
            :data="tableData"
            style="width: 100%; z-index: 1000"
            @selection-change="selectChange"
          >
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column
              type="index"
              :label="$l('序号')"
              min-width="80"
              align="center"
            ></el-table-column>
            <el-table-column
              :label="$l('公告标题')"
              prop="title"
              align="center"
              min-width="200"
            ></el-table-column>
            <el-table-column
              :label="$l('创建人员')"
              prop="creator"
              align="center"
              min-width="120"
            ></el-table-column>
            <el-table-column
              :label="$l('公告时间')"
              prop="startDate"
              align="center"
              min-width="200"
              sortable
            ></el-table-column>
            <el-table-column
              :label="$l('公告内容')"
              prop="content"
              align="center"
              min-width="200"
            ></el-table-column>
            <el-table-column
              :label="$l('查看')"
              min-width="180"
              header-align="center"
              align="center"
              fixed="right"
            >
              <template slot-scope="scope">
                <el-button
                  @click.native.prevent="showView(scope.row)"
                  type="primary"
                  clear
                  icon="el-icon-view"
                >
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-pagination
          :current-page="pageConfig.currentPage"
          :page-sizes="pageConfig.pageSizes"
          :page-size="pageConfig.pageSize"
          :total="pageConfig.total"
          @size-change="handlePageSizeChange"
          @current-change="handleCurrentPageChange"
          layout="total, sizes, prev, pager, next, jumper"
        ></el-pagination>
      </panel>

      <el-dialog
        :title="$l('公告详情')"
        :visible.sync="noticeDetailDialogVisible"
        :modal-append-to-body="false"
        width="800px"
        class="noticeDetailDialog"
      >
        <h3>{{ notice.title }}</h3>
        <p>{{ notice.content }}</p>
        <div>
          <span>{{ notice.creator }}</span>
          <span>{{ notice.startDate }}</span>
        </div>
      </el-dialog>
    </div>
  </pagefra>
</template>

<script>
// @ is an alias to /src
import panel from "@/components/panel.vue";
import global from "@/mixins/global.js";
export default {
  name: "historyNotice",
  mixins: [global],
  components: {
    panel,
  },
  data() {
    return {
      dialogVisible: false,
      form: {
        title: "",
        creator: "",
        startDate: "",
        endDate: "",
      },
      noticeTimeValues: [],
      tableData: [],
      selectedList: [],
      loading: false,
      noticeDetailDialogVisible: false,
      notice: {},
    };
  },
  mounted() {
    this.initData();
  },
  methods: {
    handlePageSizeChange(val) {
      this.pageConfig.pageSize = val;
      this.initData();
    },
    handleCurrentPageChange(val) {
      this.pageConfig.currentPage = val;
      this.initData();
    },
    search() {
      this.pageConfig.currentPage = 1;
      this.initData();
    },
    initData() {
      this.form.pageNum = this.pageConfig.currentPage;
      this.form.pageSize = this.pageConfig.pageSize;
      this.tableData = [];
      if (this.noticeTimeValues && this.noticeTimeValues.length == 2) {
        this.form.startDate = this.$common.formatDateTime(
          this.noticeTimeValues[0]
        );
        this.form.endDate = this.$common.formatDateTime(
          this.noticeTimeValues[1]
        );
      } else {
        this.form.startDate = "";
        this.form.endDate = "";
      }
      this.loading = true;
      this.$http
        .get(this.$apiConfig.search_history_notice_url, {
          params: this.form,
        })
        .then((response) => {
          this.loading = false;
          let result = response.data;
          if (result.code == 0) {
            this.pageConfig.total = result.data.total;
            this.tableData = result.data.result;
          } else {
            this.message(result.code, result.msg);
          }
        })
        .catch((error) => {
          this.loading = false;
          this.errorMessage();
          this.$sentry.captureException(error);
        });
    },
    selectChange(selection) {
      this.selectedList = selection;
    },
    deleteHistoryNotice() {
      let len = this.selectedList.length;
      if (len == 0) {
        this.message(1, "请选择要删除的数据");
        return;
      }
      this.confirmAlert(() => {
        let idList = [];
        for (let i = 0; i < len; i++) {
          idList.push(this.selectedList[i].id);
        }
        let formData = new FormData();
        formData.append("idList", idList);
        this.$http
          .post(this.$apiConfig.delete_history_notice_url, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            let result = response.data;
            this.message(result.code, result.msg);
            if (result.code == 0) {
              this.search();
            }
          })
          .catch((error) => {
            this.errorMessage(this.messageType.delete);
            this.$sentry.captureException(error);
          });
      });
    },
    showView(row) {
      this.notice = row;
      this.noticeDetailDialogVisible = true;
    },
  },
};
</script>
<style lang="scss" scoped>
.historyNotice {
  em {
    color: red;
  }

  .noticeDetailDialog {
    z-index: 2002;
    color: #000000;
    h3 {
      text-align: center;
    }
    p {
      text-indent: 2em;
      margin: 40px 0px 50px 0px;
      font-size: 16px;
    }
    div span {
      display: block;
      text-align: right;
      margin-top: 10px;
      font-size: 14px;
    }
  }
}
</style>
